import { normalizeWorkspaceRole } from '../../../../../utils/workspaceAccess';

export const SEAT_PRICE = 40;

export function presentMember(row, currentUser) {
  const isYou = Boolean(currentUser?.sub && row.userId === currentUser.sub);
  const email = (row.email || (isYou ? currentUser.email : '') || '').trim();
  if (isYou) {
    return { ...row, isYou: true, name: 'You', email: email || 'This account' };
  }
  if (email) {
    return { ...row, isYou: false, name: email.split('@')[0], email };
  }
  return { ...row, isYou: false, name: 'Someone in this room', email: 'Email not saved yet' };
}

export function sortMembers(list) {
  const rank = (role) => {
    const r = normalizeWorkspaceRole(role);
    if (r === 'owner') return 0;
    if (r === 'admin') return 1;
    return 2;
  };
  return [...list].sort((a, b) => {
    const d = rank(a.role) - rank(b.role);
    if (d !== 0) return d;
    return (a.joinedAt || '').localeCompare(b.joinedAt || '');
  });
}

export function inviteIsOpen(inv) {
  return !inv.expiresAt || new Date(inv.expiresAt) >= new Date();
}

export function initialsFor(text) {
  const clean = String(text || '').trim();
  if (!clean) return '?';
  const local = clean.includes('@') ? clean.split('@')[0] : clean;
  const parts = local.split(/[.\-_+\s]+/).filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  return local.slice(0, 2).toUpperCase();
}

export function selfMember(user, role) {
  if (!user?.sub) return [];
  return [
    {
      userId: user.sub,
      role,
      email: user.email || null,
      joinedAt: null,
    },
  ];
}

export function peopleMetaLine({ memberCount, waitingCount, showSeats, seatsUsed, seatQty }) {
  return [
    `${memberCount} ${memberCount === 1 ? 'person' : 'people'}`,
    waitingCount ? `${waitingCount} waiting` : null,
    showSeats ? `${seatsUsed} of ${seatQty} seats used` : null,
  ]
    .filter(Boolean)
    .join(' · ');
}
